import React, { FC } from 'react';
import { ReactComponent as UserIcon } from 'assets/icons/user.svg';
import { ReactComponent as BuildingIcon } from 'assets/icons/building-icon.svg';
import { ReactComponent as RiderIcon } from 'assets/icons/motorbike.svg';
import { ReactComponent as CurrencyIcon } from 'assets/icons/coin.svg';
import { ReactComponent as LocationIcon } from 'assets/icons/location.svg';
import { OrderType } from 'models/order.model';
import { ENUM_TRIP_STATUS } from 'utils/enum';
import TripStatus from 'components/base/trip-status';
import OrderTag from 'components/base/order-tag';
import { formatNumber, getNameFromOrder, getUserName } from 'utils/functions';
type CardBodyProps = {
  order: OrderType;
};
const CardBody: FC<CardBodyProps> = ({ order }) => {
  const { order_code } = order;
  const isFailedTrip = order.is_failed_trip;
  const surge = order.surge?.kitchen_surge_estimated_time;
  const late = order.kitchen_time_elapsed;
  const name = getNameFromOrder(order);

  const rider_name = getUserName(order.rider, 'nil');
  const delivery_fee = order?.calculated_order.delivery_fee;
  const address_details = order?.calculated_order.address_details.address_line;

  return (
    <div className='px-4 py-3 space-y-2 grow'>
      <div className='flex justify-between items-center'>
        <TripStatus type={isFailedTrip ? ENUM_TRIP_STATUS.FAILED : ENUM_TRIP_STATUS.COMPLETED} />

        <span className='inline-flex gap-x-1 items-center text-sm text-gray-6'>
          <BuildingIcon />
          Partner Name
        </span>
      </div>
      <div className='flex justify-between items-center text-sm gap-10'>
        <div className='flex items-center gap-2 flex-wrap'>
          <h4 className='font-medium  text-base text-gray-6'>#{order_code?.toUpperCase() ?? ''}</h4>
          {surge && <OrderTag type='surge' />}
          {late && <OrderTag type='late' />}
        </div>

        <p className='flex min-w-fit items-center gap-2'>
          <UserIcon />
          {name}
        </p>
      </div>
      <div className='flex justify-between items-center text-sm'>
        <p className='flex items-center gap-2'>
          <RiderIcon />
          {order?.rider ? (
            <span>{rider_name}</span>
          ) : (
            <span className='text-red-4'> No rider yet</span>
          )}
        </p>
        <p className='flex items-center gap-2'>
          <CurrencyIcon />
          {formatNumber(delivery_fee)}
        </p>
      </div>
      <p className='flex items-start gap-2'>
        <LocationIcon className='mt-[4px]' /> {address_details}
      </p>
    </div>
  );
};

export default CardBody;
